import { Theme } from '@mui/material/styles'
export const sortPanelStyles = {
  title: {
    fontFamily: 'Source Sans Pro Semibold',
  },

  subTitle: {
    fontSize: '12px',
    marginLeft: 'auto',
  },
}

export const sortListItemStyles = {
  root: {
    padding: (theme: Theme) => theme.spacing(1),
    marginBottom: (theme: Theme) => theme.spacing(1),
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '14px',
    alignItems: 'center',
  },
  icon: { marginRight: (theme: Theme) => theme.spacing(0.5) },
  button: { marginLeft: 'auto' },
}
